import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import OrderUpgradeHostingComponent from "../../../components/Customer/cards/OrderUpgradeHostingComponent";

const OrderUpgradeHostingPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectHome = () => {
        navigate("/");
    }

    let redirectBack = () => {
        navigate(-1);
    }

    let redirect = (orderId) => {
        navigate('/don-dat-hang/' + orderId + '/chi-tiet-don-dat-hang.html');
    }

    return <OrderUpgradeHostingComponent
        hostingId={ params.hostingId }
        shouldRedirect={ (orderId) => redirect(orderId) }
        redirectHome={ () => redirectHome() }
        redirectBack={ () => redirectBack() }
    />;
}

export default OrderUpgradeHostingPage;